/**
 * Cinematic Angles — Sekcija 3: 9 uglova + 10. slot video (le-reveal.mp4).
 * Poslednji slot = video (isti kadar kao front) — nema tranzicije slika→video.
 */
(function () {
  const SCRUB = 0.4;

  function parseConfig(section) {
    const el = section.querySelector("[data-angles-config]");
    if (!el) return { scrollHeightVh: 540, revealScrollHeightVh: 260, angles: 9 };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { scrollHeightVh: 540, revealScrollHeightVh: 260, angles: 9 };
    }
  }

  function pad2(n) {
    return n < 10 ? "0" + n : "" + n;
  }

  function smooth(t) {
    const x = Math.max(0, Math.min(1, t));
    return x * x * (3 - 2 * x);
  }

  function initAngles(section) {
    if (section.dataset.anglesInit === "1") return;
    section.dataset.anglesInit = "1";

    const config = parseConfig(section);
    const angleEls = Array.from(section.querySelectorAll("[data-angle]"));
    const slideCount = angleEls.length;
    const photoCount = config.angles || 9;
    const revealVideo = section.querySelector("[data-reveal-video]");
    const counterNum = section.querySelector("[data-angle-counter]");
    const counterLabel = section.querySelector("[data-angle-label]");
    const ticks = Array.from(section.querySelectorAll("[data-angle-tick]"));
    const track = section.querySelector("[data-track]");
    const pin = section.querySelector("[data-pin]");

    const unified = !!document.querySelector("[data-cine-unified]");

    if (unified) {
      section.classList.add("cag--unified");
      if (track) {
        track.style.setProperty("--scroll-vh", "0");
        track.style.height = "0";
      }
    } else if (track) {
      track.style.setProperty("--scroll-vh", String(config.scrollHeightVh));
    }

    let activeIdx = -1;
    const flySegments = slideCount;

    const END_HOLD = 0.03;
    const mapFlyProgress = (globalP) => {
      const t = Math.max(0, Math.min(1, globalP));
      const travel = 1 - END_HOLD;
      const segSpan = (flySegments - 1) / flySegments;
      if (t >= travel) {
        return segSpan + ((t - travel) / END_HOLD) * (1 / flySegments);
      }
      return (t / travel) * segSpan;
    };

    let videoDuration = 0;
    let videoTargetTime = 0;
    let videoRafId = null;
    let videoPrimed = false;

    const tickVideoSeek = () => {
      videoRafId = null;
      if (!revealVideo || !videoDuration) return;
      try {
        if (Math.abs(revealVideo.currentTime - videoTargetTime) > 0.008) {
          revealVideo.currentTime = videoTargetTime;
        }
      } catch (e) {}
    };

    const scheduleVideoSeek = () => {
      if (videoRafId !== null) return;
      videoRafId = requestAnimationFrame(tickVideoSeek);
    };

    const primeVideo = () => {
      if (!revealVideo || videoPrimed) return;
      videoPrimed = true;
      const run = () => {
        try {
          revealVideo.currentTime = 0.05;
        } catch (e) {}
        try {
          const p = revealVideo.play();
          if (p && typeof p.then === "function") {
            p.then(() => revealVideo.pause()).catch(() => {});
          }
        } catch (e) {}
      };
      if (revealVideo.readyState >= 2) run();
      else revealVideo.addEventListener("loadeddata", run, { once: true });
    };

    let revealScrollP = 0;

    const setVideoPresentation = (scrollP, entering) => {
      const p = Math.max(0, Math.min(1, scrollP));
      const introFrac =
        videoDuration > 0 ? Math.min(0.45, 2.5 / videoDuration) : 0.34;
      let strength = 1;
      let width = 1;
      let feather = 1;

      if (entering || p < introFrac * 0.25) {
        strength = 1;
        width = 1;
        feather = 1;
      } else if (p < introFrac) {
        strength = 1;
        width = 1;
        feather = 1;
      } else {
        const tail = (p - introFrac) / Math.max(1 - introFrac, 0.001);
        strength = Math.max(0, 1 - tail * 0.82);
        width = Math.max(0, 1 - tail * 0.72);
        feather = Math.max(0, 1 - tail * 0.78);
      }

      const maskIn = 5 + width * 14 + feather * 4;
      const maskOut = 95 - width * 14 - feather * 4;

      section.style.setProperty("--cvr-edge-veil", strength.toFixed(3));
      section.style.setProperty("--cvr-edge-veil-width", width.toFixed(3));
      section.style.setProperty("--cvr-mask-in", maskIn.toFixed(1) + "%");
      section.style.setProperty("--cvr-mask-out", maskOut.toFixed(1) + "%");
      section.style.setProperty("--cvr-mask-feather", feather.toFixed(3));
    };

    const seekVideo = (ratio) => {
      if (!revealVideo) return;
      if (!videoDuration) videoDuration = revealVideo.duration || 0;
      if (!videoDuration) return;
      videoTargetTime = Math.max(0, Math.min(1, ratio)) * videoDuration;
      if (ratio > 0.001) primeVideo();
      scheduleVideoSeek();
      setVideoPresentation(ratio, false);
    };

    if (revealVideo) {
      const onMeta = () => {
        videoDuration = revealVideo.duration || 0;
        try {
          revealVideo.currentTime = 0;
        } catch (e) {}
      };
      if (revealVideo.readyState >= 1 && revealVideo.duration) onMeta();
      else revealVideo.addEventListener("loadedmetadata", onMeta, { once: true });
      try {
        revealVideo.load();
      } catch (e) {}
    }

    const updateFly = (globalP) => {
      const p = mapFlyProgress(globalP);
      const seg = p * flySegments;
      const segIdx = Math.min(flySegments - 1, Math.floor(seg));
      const localRaw = seg - segIdx;
      const local = smooth(localRaw);

      const slideIdx = segIdx;
      const prevIdx = slideIdx === 0 ? slideCount - 1 : slideIdx - 1;
      const nextIdx = segIdx < flySegments - 1 ? slideIdx + 1 : -1;

      const vw = window.innerWidth || 1200;
      const flyX = vw * 0.95;
      const flyZ = 320;
      const rotMax = 22;
      const isHoldEnd = segIdx === flySegments - 1 && nextIdx < 0;

      angleEls.forEach((el, i) => {
        let offset = -99;
        if (i === slideIdx) offset = 0;
        else if (nextIdx >= 0 && i === nextIdx) offset = 1;
        else if (i === prevIdx) offset = -1;
        else if (nextIdx >= 0 && i === nextIdx + 1) offset = 2;

        let tx = 0,
          tz = 0,
          rot = 0,
          scale = 1,
          op = 0;
        let cls = "";

        if (offset === 0) {
          if (isHoldEnd) {
            tx = 0;
            tz = 0;
            rot = 0;
            scale = 1;
            op = 1;
          } else {
            tx = -local * flyX;
            tz = -local * flyZ * 0.6;
            rot = -local * rotMax;
            scale = 1 - local * 0.06;
            op = 1 - local * 0.65;
          }
          cls = "is-active";
        } else if (offset === 1) {
          tx = flyX * (1 - local);
          tz = -flyZ * (1 - local) * 0.4;
          rot = (1 - local) * rotMax;
          scale = 0.92 + local * 0.08;
          op = local;
          cls = "is-next";
        } else if (offset === -1) {
          tx = -flyX * 1.15;
          tz = -flyZ * 0.7;
          rot = -rotMax * 1.1;
          scale = 0.88;
          op = 0;
          cls = "is-prev";
        } else if (offset === 2) {
          tx = flyX * 1.15;
          tz = -flyZ * 0.7;
          rot = rotMax * 1.1;
          scale = 0.88;
          op = 0;
          cls = "";
        } else {
          op = 0;
          tx = offset > 0 ? flyX * 1.4 : -flyX * 1.4;
          scale = 0.85;
        }

        el.style.setProperty("--tx", tx.toFixed(1) + "px");
        el.style.setProperty("--tz", tz.toFixed(1) + "px");
        el.style.setProperty("--rot", rot.toFixed(2) + "deg");
        el.style.setProperty("--scale", scale.toFixed(3));
        el.style.opacity = op.toFixed(3);

        const img = el.querySelector("img");
        if (img) {
          const imgShift =
            offset === 0 ? -local * 14 : offset === 1 ? (1 - local) * 14 : 0;
          img.style.setProperty("--img-shift", imgShift.toFixed(1) + "px");
        }

        el.classList.toggle("is-active", cls === "is-active");
        el.classList.toggle("is-next", cls === "is-next");
        el.classList.toggle("is-prev", cls === "is-prev");
      });

      if (isHoldEnd && revealVideo) {
        seekVideo(revealScrollP > 0 ? revealScrollP : 0);
      }

      const videoSlide = section.querySelector("[data-angle-reveal]");
      if (videoSlide) {
        if (videoSlide.classList.contains("is-next")) {
          setVideoPresentation(revealScrollP, true);
        } else if (videoSlide.classList.contains("is-active")) {
          setVideoPresentation(revealScrollP, revealScrollP < 0.08);
        }
      }

      const display = local > 0.5 && nextIdx >= 0 ? nextIdx : slideIdx;
      if (display !== activeIdx) {
        activeIdx = display;
        ticks.forEach((tick, i) => {
          tick.classList.toggle("is-on", i === display);
        });
        if (counterNum) {
          counterNum.textContent = pad2(display + 1) + " / " + pad2(slideCount);
        }
        if (counterLabel) {
          const targetEl = angleEls[display];
          const lab = targetEl && targetEl.querySelector(".cag__angle-cap-label");
          if (lab) counterLabel.textContent = lab.textContent;
        }
      }
    };

    updateFly(0);

    if (unified) {
      window.addEventListener("le-cine-angles", (e) => {
        const { active, progress } = e.detail || {};
        if (active) {
          section.classList.add("cag--live");
          section.classList.remove("cag--past");
          updateFly(typeof progress === "number" ? progress : 0);
        } else {
          section.classList.remove("cag--live");
        }
      });

      window.addEventListener("le-cine-reveal", (e) => {
        const { active, progress } = e.detail || {};
        if (active) {
          section.classList.add("cag--live");
          section.classList.remove("cag--past");
          revealScrollP = typeof progress === "number" ? progress : 0;
          updateFly(1);
          if (typeof progress === "number") seekVideo(progress);
        }
      });
      return;
    }

    const initScroll = () => {
      if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        window.addEventListener("load", initScroll, { once: true });
        return;
      }
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.create({
        trigger: track,
        start: "top top",
        end: "bottom bottom",
        scrub: SCRUB,
        pin: pin,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onEnter: () => section.classList.add("cag--live"),
        onEnterBack: () => section.classList.add("cag--live"),
        onLeaveBack: () => section.classList.remove("cag--live"),
        onUpdate: (self) => updateFly(self.progress),
      });
    };
    initScroll();

    window.addEventListener(
      "resize",
      () => {
        updateFly(activeIdx / Math.max(1, flySegments - 1));
      },
      { passive: true }
    );
  }

  const boot = () => {
    document.querySelectorAll("[data-cinematic-angles]").forEach(initAngles);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
